import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteConfig } from '../../types/routes/RouteConfig';
import { ResultLayout } from '../../views/layout/ResultLayout';
import { SearchLayout } from '../../views/layout/SearchLayout';


export const routes: Array<RouteConfig> = [
   /*  {
        path: '/404',
        defaultComponent: lazy(() => import('../views/errors/NotFoundView')),
    }, */
    {
        path: '/',       
        defaultLayout: SearchLayout,
        defaultLayoutProps: {
            headerTitle: 'Titre et tarifs en vigueur dès le 1er (demo)',
            bodyTitle: 'Quel titre de transport choisir? (demo)'
        },
        defaultComponent: lazy(() => import('../../views/search/container/SearchTransportTicketPickerContainer')),
    },
    {
        path: '/result',       
        defaultLayout: ResultLayout,
        defaultLayoutProps: {
            headerTitle: 'Titre et tarifs en vigueur dès le 1er (demo)',
            bodyTitle: 'Quel titre de transport choisir? (demo)'
        },
        defaultComponent: lazy(() => import('../../views/result/container/ResultTransportTicketPickerContainer')),
    },
    {
        path: '*',
        defaultLayout: SearchLayout,
        defaultComponent: () => <Navigate to="/404" />,
    },
];

export default routes;
